/* eslint-disable */

import { AccountCircle } from '@mui/icons-material';
import {
  Avatar,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@mui/material';
import React from 'react';

import { SettingsModal, TabNames } from 'components/SettingsModal';
import { useAppSelector } from 'hooks';

import Modal from 'components/Modal';
import { Typography } from '../Typography/Typography';
import moment from 'moment';
import { persistor } from 'store';

/**
 * Account Popover
 */

interface AccountPaperProps {
  onModalStateChange: (isOpen: boolean) => void;
}

const AccountPopover: React.FC<AccountPaperProps> = ({
  onModalStateChange
}) => {
  const { profile } = useAppSelector(state => state.auth);
  const [tab, setTab] = React.useState<TabNames>('profile');

  const [accountOpen, setAccountOpen] = React.useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    persistor.purge();
    window.location.reload();
  };

  return (
    <div className="z-2000000">
      <Grid
        container
        alignItems="center"
        style={{
          paddingTop: 10
        }}
      >
        <Grid item xs={6} style={{ paddingLeft: '16px' }}>
          <Typography variant="body1">
            {profile?.role === 'organization_admin'
              ? 'Organization Admin'
              : 'Organization Member'}
          </Typography>
        </Grid>
        <Grid item xs={6} style={{ paddingRight: '16px', textAlign: 'right' }}>
          <Typography variant="body1">V1.2.2</Typography>
        </Grid>
        <Grid item xs={12}>
          <List style={{ width: '100%' }}>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <AccountCircle />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={profile?.name}
                secondary={profile?.email}
              />
            </ListItem>
            <Typography
              style={{
                paddingLeft: '16px',
                paddingBottom: '10px'
              }}
              variant="body2"
            >
              License created on{' '}
              {moment
                .utc(profile?.license?.purchased_at)
                .local()
                .format('MMM DD, YYYY, h:mm a')}
            </Typography>
            <Divider />
            <ListItem
              button
              onClick={() => {
                setTab('account');
                onModalStateChange(true);
                setAccountOpen(true);
              }}
            >
              <ListItemText primary="Account Setting" />
            </ListItem>
            <ListItem
              button
              onClick={() => {
                setTab('password');
                onModalStateChange(true);
                setAccountOpen(true);
              }}
            >
              <ListItemText primary="Change Password" />
            </ListItem>
            <ListItem button onClick={handleLogout}>
              <ListItemText primary="Logout" />
            </ListItem>
          </List>
        </Grid>
      </Grid>
      <Modal
        open={accountOpen}
        onClose={() => {
          setAccountOpen(false);
          onModalStateChange(false);
        }}
        size="lg"
      >
        <SettingsModal openTab={tab} />
      </Modal>
    </div>
  );
};

export default AccountPopover;
